import { render, staticRenderFns } from "./GuestbookHeader.vue?vue&type=template&id=4b147382&scoped=true&"
import script from "./GuestbookHeader.vue?vue&type=script&lang=js&"
export * from "./GuestbookHeader.vue?vue&type=script&lang=js&"
import style0 from "./GuestbookHeader.vue?vue&type=style&index=0&id=4b147382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b147382",
  null
  
)

export default component.exports